import { path } from 'd3-path'
import pointer from './pointer.js'

/*
 * This helper is used to lock a tip of a shape. This can be used
 * by mixing it into a shape that has a tip, like an arrow or chevron.
 *
 * This is a mixin b/c it's used by different symbol types, and inheritance
 * would get messy.
 */
export default {

  getComponents (data, dimensions) {
    const handles = this.getHandles(dimensions)

    // Build the path and pointer objects, they'll be used to draw the symbol and its text container
    this._path = path()

    // Set the tip height
    if (!this.tipHeight) {
      // Initial render, set the tipHeight
      this.tipHeight = this.getTipHeight(dimensions, handles.map(h => h.coords))
    }

    this._pointer = pointer(this._path, dimensions, handles[0].coords, {
      tipWidth: dimensions.height,
    })

    const paths = this.getPaths(data, dimensions, handles.map(handle => handle.coords))
    return {
      handles,
      flattenedPaths:  paths.length > 1 ? this.getFlattenedPaths(data, dimensions) : paths,
      paths
    }
  },

  getTipHeight(dimensions, handles) {
    return dimensions.width - dimensions.width * handles[0][0]
  },

  /*
   * When the handle changes, we want to update the stored tipHeight
   */
  onHandleChange (handle, diff, handles, dimensions) {
    this.tipHeight = this.getTipHeight(dimensions, handles.map(h => h.coords))
  },

  onDimensionsChange(dimensions, handles) {
    // When the dimensions change, we want to update the handle position
    // so the tipHeight is maintained
    if (dimensions.diff.height) {
      this.tipHeight += dimensions.diff.height * this.tipHeight
    }
    handles[0][0] = 1 - (this.tipHeight / dimensions.width)
  }

}
